import tenant from '../../assets/img/icons/common/tenant.png';
import location from '../../assets/img/icons/common/location.png';
import subOrg from '../../assets/img/icons/common/subOrg.png';
import { SquareCheckbox } from "../../components/Inputs/SquareCheckbox/SquareCheckbox";
import { treeTypes } from '../../constants/treeState';
import { StructuralAccountType } from '../../pages/HierachyManagementDashboard/StructuralAccountType';
import { AccountIdType } from '../../constants/AccountIdType';

const MiniTreeNode = ({ node, handleCheckboxClick, treeSize }) => {



    const context = node.context;
    const isChecked = context.viewStateFlags.checkedItems;
    let isDisabled = context.viewStateFlags.disabledItems;

    const checkBoxClassName = treeSize === treeTypes.Mini ? "mini-tree-checkbox" : "";

    // Determine the icon based on accountType
    const structuralAccountTypeId = node.item.data.structuralAccountTypeId;
    
    const getNodeTitle = () => {
        
        if (!node) return "";

        // keep normal behavior
        if (node.item?.accountId !== AccountIdType.GhostAccountId) {
            return node.title;
        }

        // special title for the ghost/root node
        return node?.item?.data?.name;
    };
    let icon;
    let altText;

    switch (structuralAccountTypeId) {
        case StructuralAccountType.Tenant:
            icon = tenant;
            altText = 'tenant';
            break;
        case StructuralAccountType.Suborg:
            icon = subOrg;
            altText = 'subOrg';
            break;
        case StructuralAccountType.Location:
            icon = location;
            altText = 'location';
            break;
        default:
            icon = '❓';
    }


    const handleCheck = (event) => {
        //setModalTreeCheckedItem([node.item.accountId]);
        handleCheckboxClick(node);
    }
    

    return (
        <div className="w-100">
            <div className="d-flex align-items-center gap-7">
                {structuralAccountTypeId !== StructuralAccountType.Tenant &&
                    <SquareCheckbox
                        value={isChecked}
                        valueChangeHandler={handleCheck}
                        disabled={isDisabled}
                        checkboxClassName={checkBoxClassName}
                     />
                }
                {/* show selection checkbox for tenenat when it's a mini tree and not a ghost tenant */}
                {treeSize === treeTypes.Mini && structuralAccountTypeId === StructuralAccountType.Tenant &&
                    <SquareCheckbox
                        value={isChecked}
                        valueChangeHandler={handleCheck}
                        disabled={isDisabled}
                        checkboxClassName={checkBoxClassName}
                    />
                }
                <div className="text-center">
                    <img src={icon} alt={altText} className="w-75 h-75 img-fluid"></img>
                </div>
                {/* only show the HQ badge for full-size tree */}
                {treeSize === treeTypes.FullSize && structuralAccountTypeId === StructuralAccountType.Tenant && <span className="badge background-color-teal px-3 text-white">HQ</span>}
                {getNodeTitle()}
            </div>
        </div>
    );
};

export default MiniTreeNode;
